// store/features/api/patient.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const patientsApi = createApi({
  reducerPath: "patientsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}users/patients`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Patients"],
  endpoints: (builder) => ({
    getPatients: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        gender = "",
        status = "",
        clinic_id = "",
      }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
        });

        if (search) params.append("search", search);
        if (gender) params.append("gender", gender);
        if (status !== "") params.append("status", status);
        if (clinic_id) params.append("clinic_id", clinic_id);

        return `?${params.toString()}`;
      },
      providesTags: ["Patients"],
    }),

    addPatient: builder.mutation({
      query: (formData) => ({
        url: "/",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Patients"],
    }),

    getPatientDetails: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "Patients", id }],
    }),

    getPatientProfile: builder.query({
      query: (id) => `/${id}/profile`,
      providesTags: (result, error, id) => [{ type: "Patients", id }],
    }),

    updatepatients: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Patients"],
    }),

    deletepatients: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Patients"],
    }),

    togglePatientStatus: builder.mutation({
      query: (id) => ({
        url: `/${id}/status`,
        method: "PATCH",
      }),
      invalidatesTags: ["Patients"],
    }),
  }),
});

export const {
  useGetPatientsQuery,
  useAddPatientMutation,
  useGetPatientDetailsQuery,
  useGetPatientProfileQuery,
  useUpdatepatientsMutation,
  useDeletepatientsMutation,
  useTogglePatientStatusMutation,
} = patientsApi;
